import _Check from './check';
import _Portal from './portal';

export type { CheckProps } from './check';
export type { PortalProps } from './portal';

export const Partal = _Portal;
export const Check = _Check;
